// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFanFollowCancelBody = {
  accountId: string;
};

export type typeFanFollowCancelOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { followState: "none" | "requested" | "following" };
};

export type typeFanFollowCancelOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowCancelOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowCancelOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFanFollowCancelBody = {
  type: "object",
  properties: { accountId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["accountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFanFollowCancel(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFanFollowCancelBody);
  }

  return async function postFanFollowCancel(
    payload: typeFanFollowCancelBody,
  ): Promise<typeFanFollowCancelOutput200 | typeFanFollowCancelOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFanFollowCancel" failed before calling the network. #6e64db9af821`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#6e64db9af821" },
        },
        data: null,
      } as typeFanFollowCancelOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/fan-follow/cancel`,
      httpMethod: "POST",
      options,
    })) as typeFanFollowCancelOutput200 | typeFanFollowCancelOutput400;
  };
}
